module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/007-51fd9778b6f04ec2b2dae28ab33ddc18.jpg";